function tokenize(code) {
    var results = [];
    var tokenRegExp = /\s*([A-Za-z]+|%|[0-9]+(.[0-9]+)?|\S)\s*/g;

    var m;
    while ((m = tokenRegExp.exec(code)) !== null)
        results.push(m[1]);
    return results;
}
function isNumber(token) {
    return token !== undefined && token.match(/^[0-9]+$/) !== null;
}
function isName(token) {
    return token !== undefined && token.match(/^[A-Za-z]+$/) !== null;
}
function isUnit(token) {
    return token !== undefined && token.match(/^(%|s|px)$/) !== null;
}
function parse(code) {
    var tokens = tokenize(code);
    var position = 0;

    function peek() {
        return tokens[position];
    }
    function consume(token) {
        position++;
    }

    function parsePrimaryExpr() {
        var t = peek();
        if (isNumber(t)) {
            consume(t);
            var u = peek();
            if (isUnit(u)) {
                consume(u);
                return {type: "number", value: t, unit: u};
            }
            return {type: "number", value: t};
        } else if (isName(t)) {
            consume(t);
            return {type: "name", id: t};
        } else if (t === "(") {
            consume(t);
            var expr = parseExpr();
            if (peek() !== ")")
                throw new SyntaxError("expected )");
            consume(")");
            return expr;
        } else {
            throw new SyntaxError("expected a number, a variable, or parentheses");
        }
    }

    function parseMulExpr() {
        var expr = parsePrimaryExpr();
        var t = peek();
        while (t === "*" || t === "/") {
            consume(t);
            var rhs = parsePrimaryExpr();
            expr = {type: t, left: expr, right: rhs};
            t = peek();
        }
        return expr;
    }

    function parseExpr() {
        var expr = parseMulExpr();
        var t = peek();
        while (t === "+" || t === "-") {
            consume(t);
            var rhs = parseMulExpr();
            expr = {type: t, left: expr, right: rhs};
            t = peek();
        }
        return expr;
    }

    var result = parseExpr();

    if (position !== tokens.length) {
        throw new SyntaxError("unexpected '" + peek() + "'");
    }

    return result;
}

function calc(code) {
    var variables = Object.create(null);
    variables.e = Math.E;
    variables.pi = Math.PI;
    var unit = "";

    function evaluate(obj) {
        switch (obj.type) {
            case "number":  {
                if (obj.unit) {
                    unit = obj.unit;
                }
                return parseInt(obj.value);
            }
            case "name":  return variables[obj.id] || 0;
            case "+":  return evaluate(obj.left) + evaluate(obj.right);
            case "-":  return evaluate(obj.left) - evaluate(obj.right);
            case "*":  return evaluate(obj.left) * evaluate(obj.right);
            case "/":  return evaluate(obj.left) / evaluate(obj.right);
        }
    }
    return evaluate(parse(code)) + unit;
}

export default calc;
